import { createStore } from "redux";
import allReducers from "./reducers/index";
import profileReducers from 'src/redux/reducers/profile';
const store = createStore(
    allReducers
);
export default store
